<template>
  <div class="add-professional-page">
    <el-form ref="form" :model="form" :rules="formRules" label-width="120px" label-position="left" class="form">
      <el-form-item label="专业编号：" prop="number">
        <el-input v-model="form.number" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="专业名称：" prop="name">
        <el-input v-model="form.name" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="专业层次：" prop="professionalLevel">
        <el-select v-model="form.professionalLevel">
          <el-option v-for="(item, index) of professionalLevels" :key="item" :label="item" :value="index" />
        </el-select>
      </el-form-item>
      <el-form-item label="学制：" prop="year">
        <!-- <el-input v-model="form.year" placeholder="请输入" /> -->
        <el-select v-model="form.year" filterable allow-create default-first-option>
          <el-option v-for="item of yearOptions" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否全日制：" prop="fullTime">
        <el-select v-model="form.fullTime">
          <el-option label="全日制" :value="true" />
          <el-option label="非全日制" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item label="专业描述：">
        <el-input v-model="form.remark" type="textarea" rows="5" placeholder="请输入" />
      </el-form-item>
    </el-form>
    <Btn
      :btnText="id ? '确认修改' : '确认添加'"
      className="primary"
      style="margin-left: 250px"
      :fontSize="14"
      :width="103"
      :height="37"
      @handleClick="handCreate"
    />
  </div>
</template>

<script>
import Btn from "../../components/Btn.vue";
import { create, getById, update } from '@/api/business'
export default {
  components: { Btn },
  inject: ['$setTitle'],
  data() {
    return {
      title: '添加专业',
      id: undefined,
      form: {},
      formRules: {
        number: [{ required: true, message: '不能为空', trigger: 'change' }],
        name: [{ required: true, message: '不能为空', trigger: 'change' }],
        professionalLevel: [{ required: true, message: '不能为空', trigger: 'change' }],
        year: [{ required: true, message: '不能为空', trigger: 'change' }],
        fullTime: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
      professionalLevels: ['专科', '本科', '硕士研究生', '博士研究生'],
      yearOptions: ['二年制', '三年制', '四年制', '五年制']
    }
  },
  created() {
    const { id } = this.$route.query
    console.log(id)
    let title = '添加专业'
    if (id) {
      title = '编辑专业'
      this.id = id
      this.getInfo()
    }
    this.$setTitle(title)
    this.$forceUpdate()
  },
  methods: {
    getInfo() {
      getById({ id: this.id }).then(res => {
        this.form = res.data.d
      })
    },
    handCreate() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let fun = create
          if (this.id) fun = update
          fun({
            ...this.form,
            level: 1,
            levelName: '专业'
          }).then(res => {
            this.$_message({
              message: this.id ? '修改成功!' : '添加成功!'
            })
            this.back()
          })
        }
      })
    },
    back() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.form{
  width: 500px;
}
</style>


// WEBPACK FOOTER //
// src/views/educational/addProfessional.vue